<script setup>
  defineProps({
    title: {
      type: String,
      required: true,
    },
  });
</script>

<template>
  <section class="mt-6">
    <h2 class="mb-2 text-xl font-semibold">{{ title }}</h2>
    <slot></slot>
  </section>
</template>
